















import { useConfigStore } from '@/store/config';
import { defineComponent } from '@vue/composition-api';
import { windowHelper } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'TncModule',
  props: {},
  setup() {
    const configStore = useConfigStore();
    const { tncModuleConfig } = configStore.config.commonConfig;

    const go = (url: string) => {
      if (url) {
        windowHelper.redirect(url, 300);
      }
    };
    return {
      tncModuleConfig,
      go,
    };
  },
});
